module.exports = __webpack_public_path__ + "files/9b9b43bc39f89e3574a7b056adbdb37a.svg";